import { render, staticRenderFns } from "./VerticalSwitch.vue?vue&type=template&id=17e6b814&"
import script from "./VerticalSwitch.vue?vue&type=script&lang=js&"
export * from "./VerticalSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports